module.exports = __webpack_public_path__ + "img/google-play.e0c30363.svg";